import { FormikValues } from 'formik';

export function errorHelper(formik: FormikValues, field: string) {
  return {
    showError: !!(formik.errors[field] && formik.touched[field]),
    errorText: formik.errors[field] && formik.touched[field] ? formik.errors[field] : null,
  };
}
